/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/oskaddV2"

// Shared style definitions
const sectionTitleStyle = "font-['EFCOBrookshire'] text-[38px] text-[#478F1F] leading-[1]"
const sectionTitle2Style = "font-['TANSummers'] text-[30px] text-[#478F1F]"
const itemTitleStyle = "font-['TANSummers'] text-[20px] text-[#478F1F]"
const itemSubtitleStyle = "font-['TANSummers'] text-[12px] text-[#1B4800]"
const itemSubtitleStyle2 = "font-['TANSummers'] text-[12px] text-[#478F1F]"

const oskaddV2: CommunityData = {
  code: "oskadd",
  name: "Oskadd",
  inviteCode: "carola",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/osk-225`,
  socials: {
    instagramLink: "",
    soundcloudLink: "",
  },
  styles: {
    global: {
      werzLogoColor: "#154820",
      counterColor: "#154820",
      alternativeLogo: {
        src: `${S3_PREFIX}/web-logo.png`,
        styles: "w-[156px] object-contain",
      },
      logo: {
        src: `${S3_PREFIX}/web-logo.png`,
        styles: "w-[264px] h-[80px] object-contain",
      },
      modalWindow: {
        container: "bg-[#FEFEF9] !border-0",
        title: "",
        subtitle: "",
      },
      bgColor: "#FAF6E9",
      asideStyles: "border-r border-[#478F1F]",
      asideBg: "#FAF6E9",
      contentBg: "#FAF6E9",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}/web-bg.jpg`,
      bgMobile: `${S3_PREFIX}/web-bg.jpg`,
      nonMemberBg: `${S3_PREFIX}/web-bg.jpg`,
      mainFont: "font-['TANSummers']",
      primaryButton:
        "w-full sm:w-fit !h-12 bg-[#154820] border-[2px] border-[#154820] !px-6 !text-base !leading-[1] font-['TANSummers'] font-normal !text-[#FAF6E9] rounded-[8px] whitespace-nowrap",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#FAF6E9",
      separator: "",
      item: "font-['EFCOBrookshire'] font-normal text-[20px] flex items-center justify-center text-[#478F1F] !pt-1 -ml-2",
      itemSelected: "!opacity-100",
    },
    communityLanding: {
      container: "!p-0 !m-0 border-none rounded-none",
      titles: sectionTitleStyle,
      emptyOrLoadingState: `!mx-4 sm:!mx-8 ${itemSubtitleStyle}`,
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle: `${sectionTitleStyle} pl-4 sm:pl-8 !mb-4 sm:mb-6`,
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] h-full overflow-hidden",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover rounded-none",
          placeholderMedia: "w-full h-full bg-gray-400 rounded-none",
          content: "flex flex-col py-4 bg-transparent",
          title: itemTitleStyle,
          subtitle: `${itemSubtitleStyle} mt-2`,
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle: `${sectionTitleStyle} pl-4 sm:pl-8 !mb-4 sm:mb-6`,
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover rounded-none",
          placeholderMedia: "w-full h-full bg-gray-400 rounded-none",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent",
          title: itemTitleStyle,
          subtitle: `${itemSubtitleStyle} mt-2`,
          location: `${itemSubtitleStyle} mt-2`,
          date: `${itemSubtitleStyle} mt-2`,
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: sectionTitleStyle,
        text: itemSubtitleStyle,
        customShopImage: "",
        customShopImageStyle: "!rounded-none !border-0 bg-gray-400",
        sectionTitle: `${sectionTitleStyle} !mb-4 !sm:mb-6`,
      },
    },
    eventV2: {
      container: "flex flex-col border-none rounded-none",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 rounded-none !border-0",
        title: sectionTitle2Style,
        subtitle: `${itemSubtitleStyle} mb-4 `,
        button: "!w-fit mb-4 sm:mb-0 rounded-none",
        questions: itemSubtitleStyle,
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: sectionTitle2Style,
        text: `${itemSubtitleStyle2} mb-4 w-full`,
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: sectionTitle2Style,
        text: `${itemSubtitleStyle2} mb-4  max-w-[652px] w-full !text-[#478F1F]`,
        map: "w-full h-[206px] overflow-hidden rounded-none border border-[#154820]",
        mapPinColor: "#478F1F",
        mapStrokeColor: "#154820",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: sectionTitle2Style,
        text: itemSubtitleStyle2,
      },
      tickets: {
        header: sectionTitle2Style,
        outerContainer: "flex flex-col sm:p-8 p-4",
        innerContainer: "flex flex-col mt-4 rounded-none overflow-hidden",
        ticket: {
          container: "flex flex-row justify-between gap-4 leading-auto py-4",
          media: "!hidden",
          name: "font-['TANSummers'] text-[16px] text-[#478F1F] font-normal",
          description: "font-['TANSummers'] text-[13px] text-[#1B4800] font-normal",
          price: "font-['TANSummers'] text-[16px] text-[#1B4800] font-normal",
          quantity: "font-['TANSummers'] text-[13px] text-[#154820] font-normal",
          status: "font-['TANSummers'] text-[16px] text-[#478F1F] font-normal",
          counterContainer:
            "bg-transparent !w-fit font-['TANSummers'] text-[13px] rounded-md border border-[#154820] items-center",
          button:
            "font-['TANSummers'] text-[13px] py-2 px-3 bg-transparent !w-fit rounded-md border border-[#154820] text-[#154820]",
          plusMinusColor: "#154820",
          descriptionCutoff: 27,
        },
      },
    },
  },
}

export default oskaddV2
